.item {
  display: flex;
  flex-direction: column;
}

.errorRow {
  display: flex;
  align-items: center;
  gap: var(--bc-margin-xs, 8px);
  padding: 6px 8px;
  border: 1px solid var(--bc-color-error, #F36B10);
  border-radius: var(--bc-border-radius, 8px);
  background: var(--bc-color-error-bg);
}

.errorText {
  color: var(--bc-color-error, #F36B10);
  font-size: 13px;
  flex: 1;
}

.errorIcon {
  color: var(--bc-color-error, #F36B10);
}

// Reload affordance in the error row.
.errorReload {
  background: none;
  border: none;
  cursor: pointer;
  color: var(--bc-color-text-secondary, #5A7494);
  font-size: 12px;
  padding: 4px 8px;
  white-space: nowrap;
  flex-shrink: 0;

  &:hover {
    color: var(--bc-color-primary, #0092FF);
  }
}
